<template>
  <div class="imei-query-dia">
    <el-dialog
      title="串号查询项目"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="850px"
      top="3%"
      @close="close"
    >
      <div style="padding-bottom: 50px;">
        <div class="flex flex-jb">
          <GardenSlwct
            style="margin-bottom: 10px;"
            :tab-data="tabData"
            :activeIndex="activeIndex"
            @tabAction="tabAction"
          >
          </GardenSlwct>
          <div>
            <el-button type="text" style="text-decoration: underline;" @click="showViewer = true"
              >查看示例</el-button
            >
            <el-button size="small" type="primary" icon="el-icon-plus" @click="openAddDia"
              >添加项目</el-button
            >
          </div>
        </div>
        <GlobalTable
          ref="GlobalTable01"
          v-loading="tableLoading"
          :columns="tableColumns"
          :data="tableDataList"
          :maxHeight="500"
          :isPagination="false"
        >
          <el-table-column slot="name" label="项目名称" align="center">
            <template slot-scope="{ row, $index }">
              <span>{{ row.name || '--' }}</span>
              <p v-if="$index === 0" style="color: #FFAF29;">(默认选中)</p>
            </template>
          </el-table-column>
          <el-table-column slot="onceOfficialPrice" label="费用" align="center" width="90px">
            <template slot-scope="{ row }">{{ row.onceOfficialPrice }}元/次</template>
          </el-table-column>
          <el-table-column
            label="排序"
            slot="sort"
            align="center"
            width="130px"
          >
            <template slot-scope="{ row }">
              <el-input-number
                style="width: 100px;"
                size="mini"
                :max="999999"
                :min="1"
                v-model="row.sort"
                @change="sortChange(row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            slot="operation"
            align="center"
            width="70px"
          >
            <template slot-scope="{ row }">
              <el-button
                size="small"
                type="text"
                style="color: #ff687b;"
                @click="removeRow(row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </GlobalTable>
      </div>
    </el-dialog>
    <el-dialog
      title="添加项目"
      :visible.sync="addDiaShow"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="el-table-container">
        <el-table
          ref="addProjectDia"
          v-loading="addDiaTableLoading"
          :data="addDiaTableData"
          tooltip-effect="dark"
          max-height="400px"
          border
          @selection-change="handSelect"
          :row-key="
            (row) => {
              return row.detectionId;
            }
          "
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            align="center"
          >
          </el-table-column>
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            label="项目名称"
            align="center"
            prop="name"
          ></el-table-column>
          <el-table-column label="费用" align="center" width="90px">
            <template slot-scope="{ row }">{{ row.onceOfficialPrice }}元/次</template>
          </el-table-column>
          <el-table-column label="已添加品牌" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.brandNames && row.brandNames.length">
                <span style="color: #0981FF;" v-for="(item,index) in row.brandNames" :key="index">
                  <span>{{ item }}</span>
                  <span v-if="index !== row.brandNames.length - 1">、</span>
                </span>
              </div>
              <span v-else>暂无</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="addDiaShow = false">取消</el-button>
        <el-button
          type="primary"
          :disabled="selectedProjectList.length === 0"
          @click.native="addDiaSure"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="() => {showViewer = false;}" :url-list="imgList" :z-index="99999" />
    <SecurityVisibleDia
      v-if="sureDiaShow"
      :dialogVisible="sureDiaShow"
      dialogTitle="操作提示"
      tipExplain=""
      :commandTipText="sureTipText"
      :commandButLoading="sureButLoading"
      @close="sureDiaShow = false"
      @commandSure="commandSure"
    />
  </div>
</template>

<script>
import _api from "@/utils/request";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import GardenSlwct from "@/components/common/gardenSlwct.vue";
import SecurityVisibleDia from "@/components/common/SecurityVisibleDia.vue";
export default {
  components: {
    ElImageViewer,
    GardenSlwct,
    SecurityVisibleDia
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeIndex: 0,
      channel: "3023",
      tabData: [
        {
          text: "3023",
          value: "3023",
          hideNum: true,
        },
        {
          text: "极速科技",
          value: "GSM",
          hideNum: true,
        },
      ],
      tableLoading: false,
      tableDataList: [],
      tableColumns: [
        { slotName: "name" },
        { slotName: "onceOfficialPrice" },
        { slotName: "sort" },
        { label: "添加时间", prop: "createTime" },
        { label: "添加人", prop: "createUser" },
        { slotName: "operation" },
      ],
      showViewer: false,
      imgList: ['https://img.fanxinghuishou.cn/20250806/130516380.png'], // 示例图
      // 添加项目弹框
      addDiaShow: false,
      addDiaTableLoading: false,
      addDiaTableData: [],
      selectedProjectList: [],
      optionRow: {}, //删除点击当前行

      sureDiaShow: false,
      sureButLoading: false,
      sureTipText: "",
      sureTipType: "",
    };
  },
  created() {
    this.getImeiConfigList();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // tabs切换（3023/极速科技）
    tabAction(val) {
      this.activeIndex = val;
      this.channel = this.tabData[val].value;
      this.getImeiConfigList();
    },
    //获取串号查询项目列表
    getImeiConfigList() {
      this.tableLoading = true;
      _api.getImeiConfigList({
        brandNo: this.currentRow.brandNo,
        brandId: this.currentRow.brandId,
        machineTypeId: this.currentRow.machineTypeId,
        channel: this.channel,
      }).then(res => {
        this.tableDataList = res.data;
        this.tableLoading = false;
      })
    },
    // 点击删除
    removeRow(row) {
      this.optionRow = row;
      this.sureTipText = "是否确认删除？";
      this.sureTipType = "del";
      this.sureDiaShow = true;
    },
    // 修改排序
    sortChange(row) {
      _api.imeiConfigSort({
        id: row.id,
        sort: row.sort,
      }).then(res => {
        this.$message.success("修改成功");
        this.getImeiConfigList();
      })
    },
    // 打开添加项目弹框
    openAddDia() {
      this.addDiaTableData = [];
      this.selectedProjectList = []
      this.addDiaShow = true;
      this.addDiaTableLoading = true;
      _api.saveImeiConfigList({
        brandNo: this.currentRow.brandNo,
        brandId: this.currentRow.brandId,
        machineTypeId: this.currentRow.machineTypeId,
        channel: this.channel,
      }).then(res => {
        this.addDiaTableData = res.data;
        this.addDiaTableLoading = false;
        this.$refs.addProjectDia.clearSelection();
      })
    },
    //多选操作
    handSelect(selection, row) {
      console.log(selection, row, "selection, rowselection, rowselection, row");
      this.selectedProjectList = selection;
    },
    // 添加确认
    addDiaSure() {
        this.sureTipText = "是否确认添加？";
        this.sureTipType = "add";
        this.sureDiaShow = true;
    },
    // 删除确认/添加确认
    commandSure(command) {
      this.sureButLoading = true;
      if(this.sureTipType === "add"){
        let configList = [];
        this.selectedProjectList.forEach(item => {
          configList.push(item.detectionId)
        })
        _api.addImeiConfigSave({
          brandNo: this.currentRow.brandNo,
          brandId: this.currentRow.brandId,
          machineTypeId: this.currentRow.machineTypeId,
          channel: this.channel,
          list: configList,
          command
        }).then(res => {
          this.$message.success("添加成功");
          this.getImeiConfigList();
          this.addDiaShow = false;
          this.sureDiaShow = false;
          this.$emit("refresh");
        }).finally(() => {
          this.sureButLoading = false;
        })
      }else if(this.sureTipType === "del"){
        _api.imeiConfigDelete({
          brandNo: this.currentRow.brandNo,
          brandId: this.currentRow.brandId,
          machineTypeId: this.currentRow.machineTypeId,
          id: this.optionRow.id,
          command,
        }).then(res => {
          this.$message.success("删除成功");
          this.getImeiConfigList();
          this.sureDiaShow = false;
          this.$emit("refresh");
        }).finally(() => {
          this.sureButLoading = false;
        })
      }
    },

  },
};
</script>

<style scoped lang="scss">
.imei-query-dia {
  .flex {
    display: flex;
    align-items: center;
  }
  .flex-jb {
    display: flex;
    justify-content: space-between;
  }
}
</style>
